import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const CardPackGroupWrapper = styled(Vertical)`
  gap: var(--double-unit);
  @media ${laptopAndAbove} {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--triple-unit);
  }
  @container (min-width: 1000px) {
    grid-template-columns: calc(42 * var(--unit)) minmax(0, 1fr) calc(
        42 * var(--unit)
      );
  }

  &.reverseDirection {
    flex-direction: column-reverse;
  }
  &.withoutStar {
    grid-template-columns: 2fr 3fr;
  }
`;
